import { forwardRef, type ReactNode } from 'react';
import { Field } from './AuthUi';

const LENGTH = 6;

interface CodeInputProps {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  /** Called once the sixth digit is entered or pasted. */
  onComplete?: (value: string) => void;
  disabled?: boolean;
  invalid?: boolean;
  hint?: ReactNode;
  describedBy?: string;
}

/**
 * A large single field for a six-digit code, as in the app. No native length
 * limit: a pasted "123 456" must keep all six digits once spaces are removed.
 * Paste, the phone's "code from Messages/Mail" suggestion and screen readers
 * all work.
 */
const CodeInput = forwardRef<HTMLInputElement, CodeInputProps>(function CodeInput(
  { id, label, value, onChange, onComplete, disabled, invalid, hint, describedBy }, ref,
) {
  return <Field ref={ref} id={id} label={label} hint={hint} invalid={invalid} describedBy={describedBy}
    type="text" inputMode="numeric" autoComplete="one-time-code" pattern="[0-9]*"
    value={value} disabled={disabled}
    onChange={event => {
      const next = event.target.value.replace(/\D/g, '').slice(0, LENGTH);
      onChange(next);
      if (next.length === LENGTH && next !== value) onComplete?.(next);
    }}
    className="text-center font-display !text-[26px] font-semibold tabular-nums tracking-[0.35em]" />;
});

export default CodeInput;
